import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { Form, Container, Grid, GridColumn, Button, Checkbox } from "semantic-ui-react";


class Consent extends PureComponent {
  static propTypes = {
    show: PropTypes.object.isRequired,
    season: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  state = {
    personalDataConsent: false
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleConsentChange = checked => {
    this.setState({ personalDataConsent: checked });
  };

  handleContinue = () => {
    if (this.state.personalDataConsent === true) {
      sessionStorage.setItem('personalDataAuthorization', 'true');
    } else {
      sessionStorage.removeItem('personalDataAuthorization');
    }
    this.props.history.push("/apply");
  };

  render() {
    const { show, season } = this.props;
    const IsGermanShoreShow = process.env.REACT_APP_IS_GERMAN_SHORE_SHOW === 'true';

    return (
      <div>
        <Container id="mainContent" className="ui">
          <Grid className="ui">
            <GridColumn className="pageShowTitle">
              <h3
                className="ui dividing header"
                style={{ color: `#${season.hexColorCodeC}` }}
              >
                {show.name} Casting
              </h3>
            </GridColumn>
          </Grid>

          <Grid className="ui stackable">
            <GridColumn className="sixteen wide">
              <h1>{IsGermanShoreShow ? 'CASTING FRAGEBOGEN' : 'CASTING QUESTIONNAIRE'}</h1>

              <style>{`
                .inner-html a {
                  color: #${season.hexColorCodeC} !important;
                }
              `}</style>

              {IsGermanShoreShow ?
                (
                  <div>
                    <p className="inner-html">
                      Durch das Ausfüllen des Fragebogens erklären Sie sich damit einverstanden, dass sämtliche von Ihnen bereitgestellten Informationen (einschließlich personenbezogener Daten) jeweils eigenständig verarbeitet werden von (i) Paramount und seinen verbundenen Unternehmen (zusammen <string>„Paramount“</string>) zu den Zwecken der Kontaktaufnahme (sofern erforderlich), des Castings sowie der Prüfung Ihrer Eignung zur Teilnahme an der Show gemäß den Bestimmungen der jeweiligen Datenschutzerklärung, abrufbar unter <a href="https://privacy.paramount.com/de/production-policy" target="_blank" rel="noopener noreferrer">
                        https://privacy.paramount.com/de/production-policy
                      </a> und (ii) Constantin Entertainment GmbH, die <string>„Produktionsfirma“</string>, zu den Zwecken der Kontaktaufnahme, des Castings, der Prüfung Ihrer Eignung zur Teilnahme an der Show, der Produktion der Show sowie der Aufzeichnung von Bild  und Tonmaterial, jeweils gemäß den Bestimmungen der Datenschutzerklärung, abrufbar unter <a href="https://www.constantin-casting.de/de/privacy" target="_blank" rel="noopener noreferrer">
                        https://www.constantin-casting.de/de/privacy
                      </a>.
                    </p>

                    <p className="inner-html">
                      <strong>Sensible Daten:</strong> Paramount und die Produktionsfirma können es erforderlich finden, sensible personenbezogene Daten von Ihnen zu erheben, um die oben genannten Zwecke zu erfüllen.
                      Zu den sensiblen personenbezogenen Daten zählen insbesondere Angaben zu Ihrer psychischen Gesundheit, Ihrer körperlichen Fitness und Gesundheit, Ihrem Sexualleben, Ihrer sexuellen Orientierung sowie Ihrer geschlechtlichen Identität.

                    </p>

                    <div className="inner-html">
                      <span>
                        <Form>
                          <div style={{ display: "flex", alignItems: "flex-start", marginBottom: 16 }}>
                            <Form.Field style={{ margin: 0, marginTop: 7 }}>
                              <Checkbox
                                defaultChecked={false}
                                onChange={(e, data) =>
                                  this.handleConsentChange(data.checked)
                                }
                                aria-label="Consent checkbox"
                              />
                            </Form.Field>

                            <div
                              style={{
                                marginLeft: 10, fontFamily: 'Lato, "Helvetica Neue", Arial, Helvetica, sans-serif',
                                fontSize: "16px",
                                lineHeight: "1.6",
                                WebkitTextSizeAdjust: "100%"
                              }}
                              className="consent-label inner-html" >

                              Zusätzliche Einwilligung

                            </div>
                          </div>
                        </Form>
                      </span>
                    </div>

                    <p className="inner-html">
                      Soweit Sie wünschen, sensible personenbezogene Daten bereitzustellen, bestätigen Sie hiermit, dass Sie Paramount und der Produktionsfirma gestatten, Ihre sensiblen personenbezogenen Daten zu den oben genannten Zwecken zu verarbeiten. Weitere Informationen darüber, wie Paramount und die Produktionsfirma Ihre personenbezogenen Daten jeweils eigenständig verarbeiten, entnehmen Sie bitte den jeweiligen Datenschutzerklärungen unter<a href="https://privacy.paramount.com/de/production-policy" target="_blank" rel="noopener noreferrer">https://privacy.paramount.com/de/production-policy</a> und <a href="https://www.constantin-casting.de/de/privacy" target="_blank" rel="noopener noreferrer">https://www.constantin-casting.de/de/privacy</a>.
                    </p>

                    <p className="inner-html">
                      <strong>Sollten Sie nicht einwilligen, stellen Sie bitte keine sensiblen personenbezogenen Daten im Rahmen des Fragebogens zur Verfügung.</strong>
                    </p>

                  </div>
                )
                :
                (
                  <div>
                    <p className="inner-html">
                      Durch das Ausfüllen des Fragebogens erkennen Sie sich damit einverstanden, dass alle Informationen (einschließlich personenbezogener Daten), die Sie bereitstellen, unabhängig verarbeitet werden durch (i) Paramount und seine verbundenen Unternehmen (zusammen <strong>„Paramount“</strong>) zu den folgenden Zwecken: Kontaktaufnahme mit Ihnen (falls erforderlich), Casting, Bewertung Ihrer Eignung zur Teilnahme an der Show, Produktion der Show, Aufzeichnung von Bildmaterial und Ausstrahlung der Show über verschiedene Kanäle sowie deren Verwertung (sofern zutreffend), einschließlich Fernsehen, digitale Medien und andere Plattformen (einschließlich sozialer und digitaler Plattformen) gemäß den Bedingungen unserer Datenschutzerklärung, (<a href="https://privacy.paramount.com/de/production-policy" target="_blank" rel="noopener noreferrer">
                        https://privacy.paramount.com/de/production-policy
                      </a>); und (ii) Constantin Entertainment GmbH, die <strong>„Produktionsfirma“</strong>, zu den Zwecken der Kontaktaufnahme mit Ihnen, des Castings, der Bewertung Ihrer Eignung zur Teilnahme an der Show, der Produktion der Show und der Aufzeichnung von Bildmaterial gemäß den Bedingungen der Datenschutzerklärung, die hier verfügbar ist
                      (<a href="https://www.constantin-casting.de/de/privacy" target="_blank" rel="noopener noreferrer">
                        https://www.constantin-casting.de/de/privacy
                      </a>).
                    </p>

                    <p className="inner-html">
                      <strong>Sensible Daten:</strong> Paramount und die „Produktionsfirma“ müssen möglicherweise sensible personenbezogene Daten von Ihnen erheben, um die oben genannten Zwecke zu erfüllen. Zu den sensiblen personenbezogenen Daten gehören Informationen zu Ihrer psychischen Gesundheit, körperlichen Fitness und Gesundheit, Ihrem Sexualleben, Ihrer sexuellen Orientierung und Ihrem Geschlecht.
                    </p>

                    <div className="inner-html">
                      <span >
                        <Form>
                          <div style={{ display: "flex", alignItems: "flex-start", marginBottom: 16 }}>
                            <Form.Field style={{ margin: 0, marginTop: 7 }}>
                              <Checkbox
                                defaultChecked={false}
                                onChange={(e, data) =>
                                  this.handleConsentChange(data.checked)
                                }
                                aria-label="Consent checkbox"
                              />
                            </Form.Field>

                            <div
                              style={{
                                marginLeft: 10, fontFamily: 'Lato, "Helvetica Neue", Arial, Helvetica, sans-serif',
                                fontSize: "16px",
                                lineHeight: "1.6",
                                WebkitTextSizeAdjust: "100%"
                              }}
                              className="consent-label inner-html">
                              Zusätzlich: Soweit Sie wünschen, sensible personenbezogene Daten bereitzustellen, bestätigen Sie bitte, dass Sie Paramount und der Produktionsfirma die Verarbeitung Ihrer sensiblen personenbezogenen Daten zu den oben genannten Zwecken gestatten. Weitere Informationen darüber, wie Paramount und die Produktionsfirma Ihre personenbezogenen Daten jeweils und unabhängig voneinander verwalten, finden Sie in deren jeweiligen Datenschutzerklärung
                              (<a href="https://privacy.paramount.com/de/production-policy" target="_blank" rel="noopener noreferrer">hier</a>)
                              und
                              (<a href="https://www.constantin-casting.de/de/privacy" target="_blank" rel="noopener noreferrer">hier</a>).
                              .. <strong>Wenn Sie nicht einwilligen, geben Sie bitte keine sensiblen personenbezogene Daten im Fragebogen an.</strong>
                            </div>
                          </div>
                        </Form>
                      </span>
                    </div>
                  </div>
                )}

              <br />
              <Button
                primary
                onClick={this.handleContinue}
              >
                {IsGermanShoreShow ? 'Fortfahren' : 'Continue' }
              </Button>
            </GridColumn>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default withRouter(Consent);





// WEBPACK FOOTER //
// ./src/components/Consent.js